export default __webpack_public_path__ + "static/media/logo-card-768w.1710511e.webp";